import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { toErrorCode } from './constants';
import type { UpdatePersonalizedPetitionTaskInput, UpdatePersonalizedPetitionTaskResponse } from './types';
import type {
	StarterDashboardV2UpdatePersonalizedPetitionTaskMutation as Mutation,
	StarterDashboardV2UpdatePersonalizedPetitionTaskMutationVariables as Variables,
} from './updatePersonalizedPetitionTask.graphql';
import { StarterDashboardV2UpdatePersonalizedPetitionTask as Document } from './updatePersonalizedPetitionTask.graphql';

export async function updatePersonalizedPetitionTask(
	input: UpdatePersonalizedPetitionTaskInput,
	{ errorReporter, gql: { fetch } }: UtilityContext,
): Promise<UpdatePersonalizedPetitionTaskResponse> {
	const { data, requestId } = await fetch<Mutation, Variables>({
		query: Document,
		variables: { input },
		rejectOnError: true,
	});

	const result = data.updatePersonalizedPetitionTask;

	if (!result.success) {
		const code = toErrorCode(result.errorMessage);
		void errorReporter.report({
			error: new Error('Failed to update personalized petition task'),
			context: { requestId, reason: code },
		});
		throw new Error(code);
	}

	return result;
}
